(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/lyckoplatsen/assets/react/router.js') >= 0) return;  svs.modules.push('/modules/lyckoplatsen/assets/react/router.js');

'use strict';

const {
  lazy,
  Suspense
} = React;
const {
  PlayerRouter,
  Route
} = svs.app.ReactRouter;
const {
  Debugger
} = svs.lyckoplatsen.react;
const {
  Loader
} = svs.components.ReactLoader;
const {
  routes,
  importModuleComponent
} = svs.lyckoplatsen;
const NavigationHandler = svs.lyckoplatsen.react.NavigationHandler;
const StartPage = lazy(importModuleComponent('page-start', 'StartPage'));
const PlayPage = lazy(importModuleComponent('page-play', 'PlayPage'));
const ResultPage = lazy(importModuleComponent('page-result', 'ResultPage'));
const CharityPayoutPage = lazy(importModuleComponent('page-charity-payout', 'CharityPayoutPage'));
const MybetsOngoingPage = lazy(importModuleComponent('page-mybets-ongoing', 'MybetsOngoingPage'));
const MybetsFinishedPage = lazy(importModuleComponent('page-mybets-finished', 'MybetsFinishedPage'));
const MybetsSubscriptionPage = lazy(importModuleComponent('page-mybets-subscription', 'MybetsSubscriptionPage'));
const RelatedPage = lazy(importModuleComponent('page-related', 'RelatedPage'));
const Router = () => {
  const showDebugger = svs.lyckoplatsen.hooks.useDebugger();
  return React.createElement(PlayerRouter, {
    basename: svs.core.data.baseUrl
  }, React.createElement(NavigationHandler, null), showDebugger && React.createElement(Debugger, null), React.createElement(Suspense, {
    fallback: React.createElement("h1", {
      className: "padding-4 align-center"
    }, React.createElement(Loader, null))
  }, React.createElement(Route, {
    component: StartPage,
    exact: true,
    path: routes.home.pattern
  }), React.createElement(Route, {
    component: PlayPage,
    exact: true,
    path: routes.play.pattern
  }), React.createElement(Route, {
    component: PlayPage,
    exact: true,
    path: routes.prolong.pattern
  }), React.createElement(Route, {
    component: PlayPage,
    exact: true,
    path: routes.editSubscription.pattern
  }), React.createElement(Route, {
    component: ResultPage,
    exact: true,
    path: routes.result.pattern
  }), React.createElement(Route, {
    component: ResultPage,
    exact: true,
    path: routes.resultDate.pattern
  }), React.createElement(Route, {
    component: CharityPayoutPage,
    exact: true,
    path: routes.charityPayout.pattern
  }), React.createElement(Route, {
    component: MybetsOngoingPage,
    exact: true,
    path: routes.mybetsOngoing.pattern
  }), React.createElement(Route, {
    component: MybetsOngoingPage,
    exact: true,
    path: routes.mybetsOngoingDetail.pattern
  }), React.createElement(Route, {
    component: MybetsFinishedPage,
    exact: true,
    path: routes.mybetsFinishedDetail.pattern
  }), React.createElement(Route, {
    component: MybetsSubscriptionPage,
    exact: true,
    path: routes.mybetsSubscriptionDetail.pattern
  }), React.createElement(Route, {
    component: RelatedPage,
    exact: true,
    path: routes.related.pattern
  }), React.createElement(Route, {
    component: MybetsFinishedPage,
    exact: true,
    path: routes.mailCorrection.pattern
  })));
};
setGlobal('svs.lyckoplatsen.react', {
  Router
});
if (!svs.lyckoplatsen.logger) {
  setGlobal('svs.lyckoplatsen.logger', svs.core.log.getLogger('module:lyckoplatsen'));
}

 })(window);